module.exports = __webpack_public_path__ + "static/media/24.9d0a27d9.jpg";